import axios from 'axios'
import slugify from 'react-slugify'
const capitalize = require('capitalize')

const shoppingUrl = process.env.REACT_APP_SHOPPING_API_ENDPOINT
const cloudloyaltyUrl = process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT
const trackingUrl = process.env.REACT_APP_TRACKING_ENDPOINT
const subscriptionKey = process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION
const urlReplaceV1 = process.env.REACT_APP_CLOUD_LOYALTY_URL_REPLACE_V1
const urlReplaceV2 = process.env.REACT_APP_CLOUD_LOYALTY_URL_REPLACE_V2
const refererApi = process.env.REACT_APP_ENVIRONMENT
const onboardingUrl = process.env.REACT_APP_PARTICIPANT_ONBOARDING_ENDPOINT
const premmiarAdminUrl = process.env.REACT_APP_PREMMIAR_ADMIN_ENDPOINT

const sortString = (a, b) => {
  var aName = slugify(a.name, { delimiter: '-' })
  var bName = slugify(b.name, { delimiter: '-' })

  if (aName > bName) {
    return 1
  } else if (bName > aName) {
    return -1
  }
  return 0
}

const sanitizeString = (string, type) => {
  var str = string.toLowerCase().replace(type, '')

  if (type === 'fisico') {
    str = str.replace('físico', '')
  }

  str = str
    .trim()
    .replace(' -', '')
    .replace('-', '')
    .replace('.', '')
    .replace('dshop', '')
  str = str
    .trim()
    .replace('-', '')
    .trim()
  str = str
    .trim()
    .replace('b2w ', '')
    .trim()
  str = str
    .trim()
    .replace('pg', '')
    .trim()
  str = str
    .trim()
    .replace('americanascom', 'americanas.com')
    .trim()
  return capitalize.words(str)
}

const getStores = async (catalogId, typeName) => {
  var retStores = []
  var stores = await axios
    .get(
      `${premmiarAdminUrl}/v1/stores/byType/${catalogId}?typeName=${typeName}`
    )
    .then(data => {
      let ret = data.data.data
      return ret.length > 0 && ret[0].stores ? ret[0].stores : []
    })
    .catch(err => {
      console.log(err)
      return []
    })

  for (let store of stores) {
    var storeNameSlug = slugify(store.name, { delimiter: '-' })
    let type = ''
    if (storeNameSlug.includes('virtual')) {
      type = 'virtual'
    } else {
      type = 'fisico'
    }
    retStores.push({
      supplierTypeId: '',
      supplierId: store.id,
      name: sanitizeString(store.name, type),
      customUrlPage: null
    })
  }

  return retStores.sort(sortString)
}
const useCacheParameters =
  process.env.REACT_APP_APIMANAGEMENT_CACHE_AVAILABILITY

const composeURL = ({ url, remoteSuffix = '', localSuffix = '' }) => {
  return (
    url &&
    `${url}/${url.indexOf('localhost') > -1 ? localSuffix : remoteSuffix}`
  )
}

const replaceVersion = (url, version, newVersion) => {
  if (!url) return url

  var urlSplitted = url.split('/')
  if (urlSplitted[0] === version) {
    urlSplitted[0] = newVersion
  } else if (urlSplitted[1] === version) {
    urlSplitted[1] = newVersion
  }
  return urlSplitted.join('/')
}

const tracking = {
  client: axios.create({
    baseURL: composeURL({ url: trackingUrl }),
    responseType: 'json'
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          const {
            oidc: {
              user: { access_token: accessToken }
            }
          } = getState()
          req.headers = {
            ...req.headers,
            Authorization: `Bearer ${accessToken}`,
            'Ocp-Apim-Subscription-Key': subscriptionKey,
            'Referer-Api': refererApi
          }
          return req
        }
      ]
    }
  }
}

const mileageApi = {
  client: axios.create({
    baseURL: composeURL({ url: cloudloyaltyUrl }),
    responseType: 'json',
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      'Referer-Api': refererApi,
      'X-Mileage-VendorId': process.env.REACT_APP_VENDOR_MILEAGE || 21140
    }
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          const {
            oidc: {
              user: { access_token: accessToken }
            }
          } = getState()
          req.headers = {
            ...req.headers,
            Authorization: `Bearer ${accessToken}`
          }
          return req
        }
      ]
    }
  }
}

const cloudloyalty = {
  client: axios.create({
    baseURL: composeURL({ url: cloudloyaltyUrl, remoteSuffix: 'cloudloyalty' }),
    responseType: 'json',
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      'Referer-Api': refererApi
    }
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          // TODO: descobrir porque algumas requisições são feitas sem nenhum endpoint
          if (!req.url) {
            return false
          }

          if (urlReplaceV1) {
            req.url = replaceVersion(req.url, 'v1', urlReplaceV1)
          }

          if (urlReplaceV2) {
            req.url = replaceVersion(req.url, 'v2', urlReplaceV2)
          }

          if (getState().oidc.user) {
            const {
              oidc: { user }
            } = getState()
            req.headers = {
              ...req.headers,
              Authorization: `Bearer ${user.access_token}`
            }

            var { profile } = user
            if (profile['custom:catalog_id']) {
              req.headers = {
                ...req.headers,
                'x-tenant': profile['custom:campaign_id'],
                'x-cachekey': window.btoa(profile['custom:catalog_id']),
                'x-gatewaycache': 'true'
              }
            }
          }

          return req
        }
      ],
      response: [
        async ({ getState }, res) => {
          var requestUrl = res.request.responseURL
          if (requestUrl.indexOf('identifier=voucher') > -1) {
            var products = res.data.products
            const productsOrder = [
              '9426b85b56bc4d9db8c5',
              '6585e4d3c3884defbfb3',
              'bb576f69dc414070a7e0',
              '73159f17916d4c918141'
            ]
            productsOrder.map(p => {
              const found = products.find(x => x.sku === p)
              if (found && found !== -1) {
                products.unshift(found)
              }
            })
            var newProducts = []
            products.map(item => {
              var i = newProducts.findIndex(x => x.sku === item.sku)
              if (i === -1) {
                newProducts.push({ ...item })
              }
            })
            res.data.products = newProducts
          }

          if (
            requestUrl.indexOf('/v1/stores/getStoresAllStatus?catalogId=') > -1
          ) {
            let catalogId = requestUrl.substring(requestUrl.indexOf('=') + 1)
            res.data.virtualVouchers = await getStores(
              catalogId,
              'Voucher Virtual'
            )
            res.data.physicalVouchers = await getStores(
              catalogId,
              'Voucher Físico'
            )
          }

          return res
        }
      ]
    }
  }
}

const availability = {
  client: axios.create({
    baseURL: composeURL({ url: cloudloyaltyUrl, remoteSuffix: 'cloudloyalty' }),
    responseType: 'json',
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      'Referer-Api': refererApi
    }
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          // TODO: descobrir porque algumas requisições são feitas sem nenhum endpoint
          if (!req.url) {
            return false
          }

          if (urlReplaceV1) {
            req.url = replaceVersion(req.url, 'v1', urlReplaceV1)
          }

          if (urlReplaceV2) {
            req.url = replaceVersion(req.url, 'v2', urlReplaceV2)
          }

          var state = getState()

          if (state.oidc.user) {
            const {
              oidc: { user }
            } = state

            req.headers = {
              ...req.headers,
              Authorization: `Bearer ${user.access_token}`
            }

            if (useCacheParameters) {
              var { profile } = user
              if (profile['custom:catalog_id']) {
                req.headers = {
                  ...req.headers,
                  'x-tenant': profile['custom:campaign_id'],
                  'x-cache-key': window.btoa(profile['custom:catalog_id']),
                  'x-gatewaycache': 'true'
                }
              }
            }
          }

          return req
        }
      ]
    }
  }
}

const onboardingApi = {
  client: axios.create({
    baseURL: composeURL({ url: onboardingUrl }),
    responseType: 'json'
  }),
  options: {
    interceptors: {
      request: [
        ({ getState }, req) => {
          const {
            oidc: {
              user: { access_token: accessToken }
            }
          } = getState()
          req.headers = {
            ...req.headers,
            Authorization: `Bearer ${accessToken}`,
            ProjectId: Buffer.from(process.env.REACT_APP_TENANT_ID).toString(
              'base64'
            )
          }
          req.headers = {
            ...req.headers,
            'Ocp-Apim-Subscription-Key':
              process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION
          }
          return req
        }
      ]
    }
  }
}
const solr = {
  client: axios.create({
    baseURL: 'https://solr.dev.ltm.grupoltm.com.br:8984/solr/products',
    responseType: 'json'
  })
}

const shopping = {
  client: axios.create({
    baseURL: composeURL({ url: shoppingUrl }),
    responseType: 'json',
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey
    }
  })
}

export default {
  tracking,
  mileageApi,
  cloudloyalty,
  onboardingApi,
  solr,
  availability,
  shopping
}



// WEBPACK FOOTER //
// ./src/redux/clients.js